import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBookingDetails } from '../services/api';

// Async thunk for fetching booking details
export const fetchBookingDetails = createAsyncThunk(
  'bookingDetails/fetchBookingDetails',
  async ({ filters = {}, pagination = {} }, { rejectWithValue }) => {
    try {
      const response = await getBookingDetails(filters, pagination);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to fetch booking details');
    }
  }
);

const initialState = {
  data: [],
  loading: false,
  error: null,
  lastFetched: null,
  filters: {
    period: '1year',
    facility: '',
    sport: '',
    pitch: '',
    from_date: '',
    to_date: ''
  },
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    limit: 10,
    hasNextPage: false,
    hasPrevPage: false
  }
};

const bookingDetailsSlice = createSlice({
  name: 'bookingDetails',
  initialState,
  reducers: {
    clearBookingDetails: (state) => {
      state.data = [];
      state.error = null;
      state.lastFetched = null;
    },
    resetError: (state) => {
      state.error = null;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookingDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookingDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data || [];
        state.pagination = action.payload.pagination || state.pagination;
        state.error = null;
        state.lastFetched = new Date().toISOString();
      })
      .addCase(fetchBookingDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.data = [];
      });
  }
});

export const { clearBookingDetails, resetError, setFilters, setPagination, setCurrentPage } = bookingDetailsSlice.actions;
export default bookingDetailsSlice.reducer;
